import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getFirstVNode as r } from "../../shared/v-node.js";
import { defineComponent as s, inject as i, withDirectives as o } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const d = s({
  name: "Target",
  setup() {
    const { setTargetRef: e, syncTarget: t } = i("VBinder");
    return {
      syncTarget: t,
      setTargetDirective: {
        mounted: e,
        updated: e
      }
    };
  },
  render() {
    const { syncTarget: e, setTargetDirective: t } = this;
    return e ? o(r("follower", this.$slots), [
      [t]
    ]) : r("follower", this.$slots);
  }
});
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/binder/src/Target.js
// module id = 186
// module chunks = 67